var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNose5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 32,
    viewBox: "0 0 60 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7118 13.8301C11.0924 15.6214 13.8859 14.8716 12.2665 16.6628C18.2584 17.8709 15.4648 18.6207 21.4567 19.8287C31.0345 22.7586 32.7523 21.3701 37.813 19.8287C42.1855 18.4957 46.2746 16.5378 50.9304 16.2046L45.3839 13.2053C53.3191 10.9141 58.9061 22.9947 57.9345 0C59.7563 3.16593 59.9588 7.37329 59.9588 11.1224C59.9588 18.0556 53.4764 22.89 45.6415 25.731C36.8801 28.9079 26.4274 29.5921 21.4567 27.931C11.9831 24.7651 2.46889 23.7931 0.444603 16.5378C-1.01289 8.08146 1.49724 13.6218 2.46889 13.8301C7.48914 14.9132 7.3272 12.2472 12.6713 13.8301H12.7118Z",
    fill: "#C37B58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3846 13.2054C48.6639 12.2889 53.3198 14.1218 50.9311 16.2047C46.923 19.7455 42.6315 20.8286 37.8137 19.8288C39.2307 16.0797 41.9433 14.1635 45.3846 13.2054Z",
    fill: "#382A23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.905 13.2056C10.6256 12.2892 5.96976 14.1221 8.35842 16.2049C12.3665 19.7458 16.658 20.8289 21.4758 19.8291C20.0588 16.08 17.3463 14.1637 13.905 13.2056Z",
    fill: "#382A23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNose5);
export default __webpack_public_path__ + "static/media/nose-5.ac07c1bbb92ba2316042571c23b30eb7.svg";
export { ForwardRef as ReactComponent };